import { getCsrfToken } from '@/lib/http';
import { queryClient } from '@/lib/queryClient';

async function postLogout(): Promise<void> {
  const headers: Record<string, string> = {};
  const csrfToken = getCsrfToken();

  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }

  const response = await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
    headers,
  });

  if (!response.ok && response.status !== 401) {
    const message = (await response.text()) || response.statusText;
    throw new Error(`${response.status}: ${message}`);
  }
}

export async function logoutAndRedirect(redirectPath = '/'): Promise<void> {
  try {
    await postLogout();
  } catch (error) {
    console.warn('Logout request failed; clearing local auth state anyway', error);
  } finally {
    queryClient.setQueryData(['/api/auth/user'], null);
    queryClient.setQueryData(['/api/auth/me'], null);
    queryClient.removeQueries({ queryKey: ['/api/auth/user'] });
    queryClient.removeQueries({ queryKey: ['/api/auth/me'] });
    window.location.href = redirectPath;
  }
}
